import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import { useInView } from 'react-intersection-observer'
import SelectorFilterOrderModal from './SelectorFilterOrderModal'
import { useIsTenant } from '../../contexts/TenantContext'
import constants from '../../common/constants'
import './index.css'

import CustomRefinementList from '../../functional-components/CustomRefinementList'
import CustomAccordion from '../Accordion'

const BlueRadio = withStyles({
  root: {
    color: '#0071ce',
    '&$checked': {
      color: '#0071ce',
    },
    padding: '5px',
  },
  checked: {},
})((props) => <Radio color="default" {...props} />)

const StyledFormControlLabel = withStyles({
  label: {
    fontFamily: 'Bogle',
    color: '#414042',
  },
  root: {
    marginLeft: '-6px',
  },
})(FormControlLabel)

const FilterAndOrder = ({
  searchState,
  handleFacetClick,
  parsedFacets,
  handleFilterClick,
  isMobile,
  optionsSortBy,
  handleSortBy,
}) => {
  const initialFacets = searchState.refinementList
    ? Object.keys(searchState.refinementList)
        .map((facet) => searchState.refinementList[facet].map((facetValue) => ({ facet, facetValue })))
        .flat(1)
    : []
  const [facets, setFacets] = useState(initialFacets)
  const [unsortedFacets, setUnsortedFacets] = useState({})
  const [showModal, setShowModal] = useState(false)
  const sort =
    searchState && searchState.sortBy
      ? optionsSortBy.find((item) => item.value === searchState.sortBy)
      : { label: '', value: '' }
  const [sortOption, setSortOption] = useState(sort)
  const { ref, inView } = useInView({
    threshold: 0.8,
  })
  const isSOD = useIsTenant(constants.tenant.SOD)

  const updateRefinementList = (facet) => {
    const facetKey = facet.facetId || facet.facet
    if (searchState && searchState.refinementList) {
      if (searchState.refinementList[facetKey]) {
        if (searchState.refinementList[facetKey].includes(facet.facetValue)) {
          const filtered = searchState.refinementList[facetKey].filter((value) => value !== facet.facetValue)
          // eslint-disable-next-line no-param-reassign
          searchState.refinementList[facetKey] = filtered
        } else {
          searchState.refinementList[facetKey].push(facet.facetValue)
        }
      } else {
        // eslint-disable-next-line no-param-reassign
        searchState.refinementList[facetKey] = [facet.facetValue]
      }
    } else {
      // eslint-disable-next-line no-param-reassign
      searchState.refinementList = {}
      // eslint-disable-next-line no-param-reassign
      searchState.refinementList[facetKey] = [facet.facetValue]
    }
  }

  const setFacetSelection = (facet) => {
    const removeElement = facets.find((element) => element.facetValue === facet.facetValue)
    const selectedFacets = removeElement
      ? [...facets.filter((value) => value.facetValue !== facet.facetValue)]
      : [...facets, facet]
    setFacets(() => [...selectedFacets])
    updateRefinementList(facet)
  }

  const setUnsortedFacetSelection = (facet) => {
    setUnsortedFacets((unsortedFacets) => ({ ...unsortedFacets, [facet.name]: facet }))
  }

  const cleanFilterSelection = () => {
    setFacets([])
    handleFacetClick([], true)
    handleSortBy('price_asc')
    setSortOption({ label: 'Mayor precio', value: 'price_asc' })
    setShowModal(false)
  }

  const sendSelectedFacets = () => {
    handleFacetClick(facets, true)
    handleFilterClick(unsortedFacets[constants.FILTERS.PRICE])
    handleSortBy(sortOption.value)
    setShowModal(false)
  }

  const handleSortOptionChange = (event) => {
    const sort = optionsSortBy.find((item) => item.label === event.target.value)
    setSortOption(sort)
  }

  const facetNumber = searchState.refinementList
    ? Object.keys(searchState.refinementList).reduce(
        (acc, filter) => acc + searchState.refinementList[filter].length,
        0
      )
    : 0

  const getCSSDisplay = inView && 'filter-and-order__button-sticky-display-none'

  const getCSSSOD = isSOD && 'filter-and-order__button-sticky-sod'

  const selectedValueFacets =
    searchState.minPrice && searchState.maxPrice ? { min: searchState.minPrice, max: searchState.maxPrice } : {}

  return (
    <Fragment>
      <div className="filter-and-order__main" ref={ref}>
        <button
          type="button"
          id="filterAndOrder"
          onClick={() => {
            setShowModal(true)
          }}
          onKeyPress={() => {
            setShowModal(true)
          }}
          className="filter-and-order__button"
        >
          <img className="filter-and-order__icon" alt="filters" src="/catalogo/images/filter_icon.svg" />
          <span>Filtrar y ordenar</span>
          {facetNumber > 0 && <div className="filter-and-order__counter">{facetNumber}</div>}
        </button>

        <SelectorFilterOrderModal
          modalIsOpen={showModal}
          setShowModal={setShowModal}
          facets={facets}
          sortOption={sortOption}
          selectedFacets={searchState.refinementList}
        >
          <Fragment>
            <div className="filter-and-order__container">
              <div>
                <CustomAccordion title="Ordenar por" isMobile={isMobile} expanded>
                  <RadioGroup
                    aria-label="Ordenar por"
                    name="ordenar por"
                    value={sortOption.label}
                    onChange={handleSortOptionChange}
                  >
                    {optionsSortBy.map((option, i) => (
                      <StyledFormControlLabel
                        key={i}
                        value={option.label}
                        control={<BlueRadio />}
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>
                </CustomAccordion>
              </div>
              {parsedFacets &&
                parsedFacets.map((facet) => (
                  <CustomRefinementList
                    key={`desktop-facet-${facet.name}`}
                    selectedFacets={searchState.refinementList}
                    selectedValues={selectedValueFacets}
                    handleFacetClick={setFacetSelection}
                    handleFilterClick={setUnsortedFacetSelection}
                    name={facet.name}
                    items={facet.items}
                    facetId={facet.id}
                    values={facet.values}
                    sortable={facet.sortable}
                    isMobile={isMobile}
                    expanded={!isMobile}
                  />
                ))}
            </div>
            <div className="filter-and-order__action-buttons-container">
              <button
                type="button"
                className="filter-and-order__action-button"
                onClick={() => cleanFilterSelection()}
                onKeyPress={() => cleanFilterSelection()}
              >
                Borrar
              </button>
              <button
                primary
                type="button"
                className="filter-and-order__action-button filter-and-order__action-button-primary"
                onClick={() => sendSelectedFacets()}
                onKeyPress={() => sendSelectedFacets()}
              >
                Aplicar
              </button>
            </div>
          </Fragment>
        </SelectorFilterOrderModal>
      </div>
      <button
        type="button"
        className={`filter-and-order__button-sticky ${getCSSDisplay} ${getCSSSOD}`}
        id="filterAndOrder"
        onClick={() => setShowModal(true)}
        onKeyPress={() => setShowModal(true)}
      >
        <img alt="filters" src="/catalogo/images/filter_icon.svg" className="filter-and-order__icon" />
        <span>Filtrar y ordenar</span>
        {facetNumber > 0 && <div className="filter-and-order__counter">{facetNumber}</div>}
      </button>
    </Fragment>
  )
}

FilterAndOrder.propTypes = {
  searchState: PropTypes.object.isRequired,
  handleFacetClick: PropTypes.func.isRequired,
  handleSortBy: PropTypes.func.isRequired,
  parsedFacets: PropTypes.array.isRequired,
  isMobile: PropTypes.bool.isRequired,
  optionsSortBy: PropTypes.array.isRequired,
}

export default FilterAndOrder
